import {
  colourSwatchSelectorControlSize,
  colourSwatchSelectorWidth,
} from '@/features/shared/components/colourSwatchSelectorMetrics';
import { s } from '@/theme/tokens';
import { formFieldLabelSx } from '@/ui/primitives/formFieldStyles';
import type { SxProps, Theme } from '@/ui/primitives';

export type ProjectBadgeFieldTextColumnWidth = string | Record<string, string>;

export const projectBadgeCheckboxColumnWidth = colourSwatchSelectorControlSize;
export const projectBadgeCheckboxIconSize = '28px';

export const projectBadgeHelperTextSx = {
  mt: s('xxs'),
  fontSize: '13px',
} as const;

export const projectBadgeLabelSx = [formFieldLabelSx, { fontWeight: 400 }] as SxProps<Theme>;

export const buildProjectBadgeGridTemplateColumns = (
  textFieldColumnWidth: ProjectBadgeFieldTextColumnWidth,
): string | Record<string, string> => {
  const columns = (fieldColumnWidth: string): string =>
    `${fieldColumnWidth} ${colourSwatchSelectorWidth} ${projectBadgeCheckboxColumnWidth} auto`;

  if (typeof textFieldColumnWidth === 'string') {
    return columns(textFieldColumnWidth);
  }

  return Object.fromEntries(
    Object.entries(textFieldColumnWidth).map(([breakpoint, fieldColumnWidth]) => [
      breakpoint,
      columns(fieldColumnWidth),
    ]),
  );
};

export const buildProjectBadgeRootSx = (textFieldColumnWidth: ProjectBadgeFieldTextColumnWidth) =>
  ({
    display: 'grid',
    gridTemplateColumns: buildProjectBadgeGridTemplateColumns(textFieldColumnWidth),
    alignItems: 'start',
    columnGap: s('sm'),
    rowGap: s('sm'),
    width: '100%',
    maxWidth: '100%',
  }) as const;

export const projectBadgePreviewFrameSx = {
  height: colourSwatchSelectorControlSize,
  display: 'flex',
  alignItems: 'center',
  ml: s('xs'),
} as const;

export const projectBadgeCheckboxFrameSx = {
  width: projectBadgeCheckboxColumnWidth,
  minWidth: projectBadgeCheckboxColumnWidth,
  maxWidth: projectBadgeCheckboxColumnWidth,
  height: colourSwatchSelectorControlSize,
  minHeight: colourSwatchSelectorControlSize,
  maxHeight: colourSwatchSelectorControlSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

export const projectBadgeCheckboxSx = {
  p: s('none'),
  width: colourSwatchSelectorControlSize,
  minWidth: colourSwatchSelectorControlSize,
  maxWidth: colourSwatchSelectorControlSize,
  height: colourSwatchSelectorControlSize,
  minHeight: colourSwatchSelectorControlSize,
  maxHeight: colourSwatchSelectorControlSize,
  '& .MuiSvgIcon-root': {
    fontSize: projectBadgeCheckboxIconSize,
  },
} as const;
